// bootstrap.min - BEGIN
/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
	this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);

// bootstrap.min - END

// BBB CODE BEGIN
// accordion
// FAQ accordion
	var allPanels = $('.accordion > dd').hide();

	$('.accordion > dt').click(function () {
		if (!$(this).next().is(":visible")) {
			allPanels.slideUp();
			$('.accordion span.glyphicon-plus').removeClass('glyphicon-active');
			$(this).find('span.glyphicon-plus').addClass('glyphicon-active');
			$(this).next().slideDown();
		}
		return false;
	});

	$($('.accordion dd')[0]).show();
// FAQ accordion end


// var pdpAllPanels = $('.accordion .acc-content').hide();

// $('.accordion > dt > a').click(function () {
//   if (!$(this).parent().next().is(":visible")) {
//     allPanels.slideUp();
//     $('.accordion small.right').html('+');
//     $(this).find('small.right').html('-');
//     $(this).parent().next().slideDown();
//   }
//   return false;
// });

// bbb code
// if ($(window).width() <= 768) {
//   var xsPanels = $('.xs-accordion .acc-content').hide();
// }

// $('.xs-accordion .acc-title').click(function () {
//   if ($(this).next('.acc-content').is(":visible")) {
//    $(this).next().slideUp();
//    $(this).find('span.glyphicon-plus').removeClass('glyphicon-active');
//  }else{
//   $(this).next().slideDown();
//   $(this).find('span.glyphicon-plus').addClass('glyphicon-active');
// }
// });

// $($('.xs-accordion .acc-content')[0]).show();
// $($('.xs-accordion .acc-content')[5]).show();
// $($('.xs-accordion dd')).show();

//Recipes all categories mobile slide UP/DOWN
// var xsPanels = $('.recipe-accordion .content-box').hide();

// $('.recipe-accordion .head-up ').click(function () {
//  $('.content-box').slideDown();
//  $(this).find('span.glyphicon-plus').removeClass('glyphicon-active');
// });
// $('.recipe-accordion .head-down ').click(function () {
//  $('.content-box').slideUp();
//  $(this).find('span.glyphicon-plus').removeClass('glyphicon-active');
// });
//Recipes all categories mobile slide UP/DOWN

// $('.accordion .acc-title').click(function () {
//   if (!$(this).next().is(":visible")) {
//     pdpAllPanels.slideUp();
//     $('.accordion span.glyphicon-plus').removeClass('glyphicon-active');
//     $(this).find('span.glyphicon-plus').addClass('glyphicon-active');
//     $(this).next().slideDown();
//   }
//   return false;
// });
// bbb code

// $($('.accordion .acc-content')[0]).show();


	jQuery(document).ready(function ($) {

// zopim init
$zopim(function() {
	$zopim.livechat.window.show();
});
		 // end zopim init

		var windowwidth = $(window).width();
		if (windowwidth <= '768') {

    // Pinning Nav
    // $('#header.mobile_nav-fixed--false').jPinning();

    // Mobile Logo Bar section
			$('.logo-bar').flickity({
      // options
				freeScroll: true,
				contain: true,
      // disable previous & next buttons and dots
				prevNextButtons: false,
				pageDots: true
			});
		}

  // Custom RC dropdown container
  // $(document).on('click', '.variant-dropdown-display', function () {
  //   $('.variant-dropdown-options').toggle();
  // })
  // $(document).on('click', '.variant-dropdown-option', function () {
  //   $('.variant-dropdown-display').html($(this).html());
  //   $('.variant-dropdown-options').hide();
  //   var data_freq = $(this).attr('data-frequency');
  //   $('.variant-dropdown-option').removeClass("selected");
  //   $(this).addClass("selected");
  //   $('select[name="properties[shipping_interval_frequency]"]').find('option').removeAttr('selected', true);
  //   $('select[name="properties[shipping_interval_frequency]"]').find('option[value="' + data_freq + '"]').attr("selected", true);
  // })

  // setTimeout(function () {
  //   $(document).find('.rc_block__type').trigger('click');
  // }, 500)

  // change add to cart text to Subscribe and Save
  // $(document).on('click', ".rc_block", function () {
  //   // if ($(".rc_block__type__autodeliver").hasClass('rc_block__type--active')) {
  //   //   $('.purchase .add_to_cart').find('span.text').text('Subscribe and Save');
  //   // } else {
  //   //   $('.purchase .add_to_cart').find('span.text').text('Add to Cart');
  //   // }

  //   // product page earn points 
  //   var points = $(".current_price").text();
  //   points = points.replace('$', '').replace(' USD', '');
  //   $('.rc-earnup-points').text(parseFloat(points).toFixed(0));
  // })

  // product gallery vertical slide
  // $('.up_arrow').on('click', function (e) {
  //   e.preventDefault();
  //   var gallery_nav = $('.product_gallery_nav');
  //   $('.product_gallery_nav').animate({
  //     scrollTop: gallery_nav.scrollTop() - 100
  //   }, 300);
  // });
  // $('.down_arrow').on('click', function (e) {
  //   e.preventDefault();
  //   var gallery_nav = $('.product_gallery_nav');
  //   $('.product_gallery_nav').animate({
  //     scrollTop: gallery_nav.scrollTop() + 100
  //   }, 300);
  // });

  // Product detail page faq section
  // $('.single-prdct-faq .readmore').html('<img src="https://cdn.shopify.com/s/files/1/2280/1825/files/down-arrow.png" height="28">');
  // $('.fulltext').hide();
  // $('.single-prdct-faq .readmore').click(function (event) {
  //   event.preventDefault();
  //   if ($(this).hasClass('zl-up') == true) {
  //     $(this).addClass("zl-down");
  //     $(this).removeClass("zl-up");
  //   } else $(this).addClass("zl-up")
  //   $(this).parent().find('.fulltext').slideToggle('slow');
  //   $(this).html($(this).html() == '<img src="https://cdn.shopify.com/s/files/1/2280/1825/files/up-arrow-small.png" height="28">' ? '<img src="https://cdn.shopify.com/s/files/1/2280/1825/files/down-arrow.png" height="28">' : '<img src="https://cdn.shopify.com/s/files/1/2280/1825/files/up-arrow-small.png" height="28">');
  // });

// frequently bought together widget
  // if ($(window).width() < 768) {
  //   setTimeout(function () {
  //     var fbt_products = $('.cbb-frequently-bought-products');
  //     $('<div class="fbt_expander_heading"><h3>Buy All Three<span class="icon-down-arrow"></span></h3></div>').insertAfter(fbt_products);
  //     $('.cbb-frequently-bought-selector-list').hide();
  //   }, 10000);

  //   $(document).on('touchstart', '.fbt_expander_heading', function (e) {
  //     $('.cbb-frequently-bought-form').slideToggle();
  //     $('.cbb-frequently-bought-selector-list').slideToggle();
  //     $(this).find('span').toggleClass('icon-down-arrow').toggleClass('icon-up-arrow');
  //   })
  // }

  // Food list page
  // $('.chk-parent').change(function (e) {
  //   $(this).parent().parent().find('ul li .cls-check-box').prop('checked', this.checked);
  // })

  // $('.supp-section .heading-toggle').click(function () {
  //   $(this).parent().parent().find('.toggle-section').slideToggle();
  //   $(this).find('.food-col').toggle();
  //   $(this).find('.food-exp').toggle();
  // })

  // turn off scroll on mobile drop down menu opened
		// var current = $(window).scrollTop();
		// $(window).on('scroll touchmove mousewheel', function (e) {
		// 	if ($('body').hasClass('is-active')) {
		// 		// console.log('asdfasdf');
		// 		$(window).scrollTop(current);
		// 		e.preventDefault();
		// 		e.stopPropagation();
		// 		return false;
		// 	}
		// })

  // mobile browse categories
  // $('.all_icons_mobile').on('touchstart', '.ham', function () {
  //   $(this).next().slideToggle();
  // })

  // Pre order button
  // setTimeout(function(){
  //   if ($('.add_to_cart').next().hasClass('tooltipstered')) {
  //     $('.add_to_cart span.text').html('<strong>Pre Order Now</strong>');
  //     $('.tooltipster-content').insertAfter('.add_to_cart');
  //   }
  // }, 3000)
  // window.alert = function () {};

// bbb
//begin fixed checkout button in cart page 
// if ($('.fixed-checkout-btn').length > 0){
//     var xsAffix = $('#cart_form').offset().top - 100; // get initial position of the element

//     var bodyTop = $('.last-item-box').offset().top + 150;

//    $(window).scroll(function () { // assign scroll event listener

//       var currentScroll = $(window).scrollTop(); // get current position

//       if ($(window).width() <= 798){

//         if (currentScroll >= xsAffix && currentScroll < bodyTop) { // apply position: fixed if you
//           $('.fixed-checkout-btn').show();
//         } else { // apply position: static
//           $('.fixed-checkout-btn').hide();
//         }
//       }

//     });

//  }
//end fixed checkout button in cart page 

	})


// header custom code begin
// document.querySelector('#mobileChat').addEventListener("click", openChat);
// document.querySelector('#desktopChat').addEventListener("click", openChat);

// function openChat() {
// 	$zopim.livechat.window.show();
// }
// header custom code end




// bbb code
var scrollContainer = $('html, body'); 
var curElem = $('ul.tabs'); 


// Begin - Fixed bar in product page
var target = $('.clone-navbar-menu');
var affix = $('.affix');

var element = document.getElementById('affix');
if (element !== null) {
	window.addEventListener('scroll', function () {
		var position = target.position();
		var height = $(window).scrollTop();
		if (height > position.top) {
			affix.css('display', 'block');
		} else {
			affix.css('display', 'none');
		}
	})
}

var scrollContainer = $('html, body'); 
var curElem = $('ul.tabs'); 
$('.tab1, .tab2, .tab3, .tab4, .tab5, .product-form-').click(function() {
	scrollContainer.animate({
		scrollTop: $( $(this).attr('href') ).offset().top}, 500);
});
//End - Fixed bar in product page

// PDP page notes popup begin
$( document ).ready(function() {

	if($('#item-notes-popup').length ){ 

// PDP Notes cookie set, get and check
		function setNotesCookie(cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires="+d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		}

		function getNotesCookie(cname) {
			var name = cname + "=";
			var ca = document.cookie.split(';');
			for(var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}

		function checkNotesCookie() {
			var pdpNotes = getNotesCookie("pdp_notes");
			if (pdpNotes != "") {
			} else {
				window.setTimeout(function(){
					$('#item-notes-popup').modal('show');
				}, 3000);
				setNotesCookie("pdp_notes", "product", 1 );
			}
		}
//end PDP Notes cookie set, get and check

		window.setTimeout(function(){
    // $('#item-notes-popup').modal('show');
			checkNotesCookie();
		}, 3000);

	}

});
// PDP page notes popup end


// slide transition mobile product slider in PDP
if ($(window).width() < 799) {
	$('.product_gallery').removeClass('slideshow_animation--fade').addClass('slideshow_animation--slide');
}
// slide transition mobile product slider in PDP


// Mobile header transition on scroll on top
// if ($(window).width() < 799) {

// 	$(function(){
// 		var lastScrollTop = 0, delta = 5;
// 		$(window).scroll(function(){
// 			var nowScrollTop = $(this).scrollTop();
// 			if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
// 				if (nowScrollTop > lastScrollTop && nowScrollTop >= 212){
//         // ACTION ON
//         // SCROLLING DOWN 
// 					$('#mobile-countdown-header').css({"transform": "translateY(-100%)", "transition": "0.25s transform ease-out, 0.25s opacity ease-out"});
// 					$('#mobile-countdown-header').removeClass('site-header--fixed');

//         //console.log('SCROLLING DOWN');
// 				} else if(nowScrollTop <= 212){
// 					$('#mobile-countdown-header').css("transform","translateY(0%)");
// 					$('#mobile-countdown-header').removeClass('site-header--fixed');
// 				} else {
//         // ACTION ON
//         // SCROLLING UP 
// 					$('#mobile-countdown-header').css({"transform": "translateY(0%)", "transition": "0.25s transform ease-out"});
// 					$('#mobile-countdown-header').addClass('site-header--fixed');
//         //console.log('SCROLLING UP');
// 				}
// 				lastScrollTop = nowScrollTop;
// 			}
// 		});
// 	});
// }
// Mobile header transition on scroll on top


//BBB Custom slideshows
//homepage logo list - begin
$('.logo-carousel').flickity({
	"adaptiveHeight": true,
	"wrapAround": true,
	"cellAlign": "center",
	"draggable": true,
	"contain": true,
	"imagesLoaded": true,
	"lazyLoad": 2,
	"pageDots": false,
	"prevNextButtons": true,
	"autoPlay": true,
	"dragThreshold": 10
});
//homepage logo list - end

// PDP nutrition slider begin
var $nutritionSlider = $('.nutrition-slider');
$nutritionSlider.flickity({
  // options
	"adaptiveHeight": true,
	"draggable": true,
	"cellAlign": "left",
	"prevNextButtons": true,
	"contain": true,
	"imagesLoaded": true

});
// PDP nutrition slider end

// homepage KMK testimonials
if ($(window).width() < 799) {

	$('.author_testimonial').flickity({
		"adaptiveHeight": true,
		"draggable": true,
		"imagesLoaded": true,
		"contain": true,
		"pageDots": false
	});
// start with 1th slide
	$('.author_testimonial').flickity( 'select', 1, true, true );
}else{
	$('.author_testimonial').flickity({
		"draggable": true,
		"imagesLoaded": true,
		"contain": true,
		"pageDots": false
	});
// start with 1th slide
	$('.author_testimonial').flickity( 'select', 1, true, true );

}

$('.author_img').flickity({
	"asNavFor": '.author_testimonial',
	"contain": true,
	"imagesLoaded": true,
	"prevNextButtons": false,
	"pageDots": false
});

// setTimeout(function(){
//   $('.author_testimonial').flickity('resize');
// }, 1000);
// homepage KMK testimonials

//BBB Custom slideshows


// Begin - Collection Page - sticky filters

// Begin ResizeSensor.js
/**
* Copyright Marc J. Schmidt. See the LICENSE file at the top-level
* directory of this distribution and at
* https://github.com/marcj/css-element-queries/blob/master/LICENSE.
*/
;
(function (root, factory) {
	if (typeof define === "function" && define.amd) {
		define(factory);
	} else if (typeof exports === "object") {
		module.exports = factory();
	} else {
		root.ResizeSensor = factory();
	}
}(typeof window !== 'undefined' ? window : this, function () {

   // Make sure it does not throw in a SSR (Server Side Rendering) situation
	if (typeof window === "undefined") {
		return null;
	}
   // Only used for the dirty checking, so the event callback count is limited to max 1 call per fps per sensor.
   // In combination with the event based resize sensor this saves cpu time, because the sensor is too fast and
   // would generate too many unnecessary events.
	var requestAnimationFrame = window.requestAnimationFrame ||
	window.mozRequestAnimationFrame ||
	window.webkitRequestAnimationFrame ||
	function (fn) {
		return window.setTimeout(fn, 20);
	};

   /**
    * Iterate over each of the provided element(s).
    *
    * @param {HTMLElement|HTMLElement[]} elements
    * @param {Function}                  callback
    */
   function forEachElement(elements, callback){
   	var elementsType = Object.prototype.toString.call(elements);
   	var isCollectionTyped = ('[object Array]' === elementsType
   		|| ('[object NodeList]' === elementsType)
   		|| ('[object HTMLCollection]' === elementsType)
   		|| ('[object Object]' === elementsType)
           || ('undefined' !== typeof jQuery && elements instanceof jQuery) //jquery
           || ('undefined' !== typeof Elements && elements instanceof Elements) //mootools
           );
   	var i = 0, j = elements.length;
   	if (isCollectionTyped) {
   		for (; i < j; i++) {
   			callback(elements[i]);
   		}
   	} else {
   		callback(elements);
   	}
   }

   /**
    * Class for dimension change detection.
    *
    * @param {Element|Element[]|Elements|jQuery} element
    * @param {Function} callback
    *
    * @constructor
    */
   var ResizeSensor = function(element, callback) {
       /**
        *
        * @constructor
        */
       function EventQueue() {
       	var q = [];
       	this.add = function(ev) {
       		q.push(ev);
       	};

       	var i, j;
       	this.call = function() {
       		for (i = 0, j = q.length; i < j; i++) {
       			q[i].call();
       		}
       	};

       	this.remove = function(ev) {
       		var newQueue = [];
       		for(i = 0, j = q.length; i < j; i++) {
       			if(q[i] !== ev) newQueue.push(q[i]);
       		}
       		q = newQueue;
       	}

       	this.length = function() {
       		return q.length;
       	}
       }

       /**
        *
        * @param {HTMLElement} element
        * @param {Function}    resized
        */
       function attachResizeEvent(element, resized) {
       	if (!element) return;
       	if (element.resizedAttached) {
       		element.resizedAttached.add(resized);
       		return;
       	}

       	element.resizedAttached = new EventQueue();
       	element.resizedAttached.add(resized);

       	element.resizeSensor = document.createElement('div');
       	element.resizeSensor.className = 'resize-sensor';
       	var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
       	var styleChild = 'position: absolute; left: 0; top: 0; transition: 0s;';

       	element.resizeSensor.style.cssText = style;
       	element.resizeSensor.innerHTML =
       	'<div class="resize-sensor-expand" style="' + style + '">' +
       	'<div style="' + styleChild + '"></div>' +
       	'</div>' +
       	'<div class="resize-sensor-shrink" style="' + style + '">' +
       	'<div style="' + styleChild + ' width: 200%; height: 200%"></div>' +
       	'</div>';
       	element.appendChild(element.resizeSensor);

       	if (element.resizeSensor.offsetParent !== element) {
       		element.style.position = 'relative';
       	}

       	var expand = element.resizeSensor.childNodes[0];
       	var expandChild = expand.childNodes[0];
       	var shrink = element.resizeSensor.childNodes[1];
       	var dirty, rafId, newWidth, newHeight;
       	var lastWidth = element.offsetWidth;
       	var lastHeight = element.offsetHeight;

       	var reset = function() {
       		expandChild.style.width = '100000px';
       		expandChild.style.height = '100000px';

       		expand.scrollLeft = 100000;
       		expand.scrollTop = 100000;

       		shrink.scrollLeft = 100000;
       		shrink.scrollTop = 100000;
       	};

       	reset();

       	var onResized = function() {
       		rafId = 0;

       		if (!dirty) return;

       		lastWidth = newWidth;
       		lastHeight = newHeight;

       		if (element.resizedAttached) {
       			element.resizedAttached.call();
       		}
       	};

       	var onScroll = function() {
       		newWidth = element.offsetWidth;
       		newHeight = element.offsetHeight;
       		dirty = newWidth != lastWidth || newHeight != lastHeight;

       		if (dirty && !rafId) {
       			rafId = requestAnimationFrame(onResized);
       		}

       		reset();
       	};

       	var addEvent = function(el, name, cb) {
       		if (el.attachEvent) {
       			el.attachEvent('on' + name, cb);
       		} else {
       			el.addEventListener(name, cb);
       		}
       	};

       	addEvent(expand, 'scroll', onScroll);
       	addEvent(shrink, 'scroll', onScroll);
       }

       forEachElement(element, function(elem){
       	attachResizeEvent(elem, callback);
       });

       this.detach = function(ev) {
       	ResizeSensor.detach(element, ev);
       };
   };

   ResizeSensor.detach = function(element, ev) {
   	forEachElement(element, function(elem){
   		if (!elem) return
   			if(elem.resizedAttached && typeof ev == "function"){
   				elem.resizedAttached.remove(ev);
   				if(elem.resizedAttached.length()) return;
   			}
   			if (elem.resizeSensor) {
   				if (elem.contains(elem.resizeSensor)) {
   					elem.removeChild(elem.resizeSensor);
   				}
   				delete elem.resizeSensor;
   				delete elem.resizedAttached;
   			}
   		});
   };

   return ResizeSensor;

}));

// End ResizeSensor.js


// BEGIN sticky-sidebar.js
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.StickySidebar = {})));
}(this, (function (exports) { 'use strict';

	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};



	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var stickySidebar = createCommonjsModule(function (module, exports) {
		(function (global, factory) {
			if (typeof undefined === "function" && undefined.amd) {
				undefined(['exports'], factory);
			} else {
				factory(exports);
			}
		})(commonjsGlobal, function (exports) {
			Object.defineProperty(exports, "__esModule", {
				value: true
			});

			function _classCallCheck(instance, Constructor) {
				if (!(instance instanceof Constructor)) {
					throw new TypeError("Cannot call a class as a function");
				}
			}

			var _createClass = function () {
				function defineProperties(target, props) {
					for (var i = 0; i < props.length; i++) {
						var descriptor = props[i];
						descriptor.enumerable = descriptor.enumerable || false;
						descriptor.configurable = true;
						if ("value" in descriptor) descriptor.writable = true;
						Object.defineProperty(target, descriptor.key, descriptor);
					}
				}

				return function (Constructor, protoProps, staticProps) {
					if (protoProps) defineProperties(Constructor.prototype, protoProps);
					if (staticProps) defineProperties(Constructor, staticProps);
					return Constructor;
				};
			}();

  /**
   * Sticky Sidebar JavaScript Plugin.
   * @version 3.3.4
   * @author Ahmed Bouhuolia <a.bouhuolia@gmail.com>
   * @license The MIT License (MIT)
   */
  var StickySidebar = function () {

    // ---------------------------------
    // # Define Constants
    // ---------------------------------
    //
  	var EVENT_KEY = '.stickySidebar';
  	var DEFAULTS = {
      /**
       * Additional top spacing of the element when it becomes sticky.
       * @type {Numeric|Function}
       */
      topSpacing: 0,

      /**
       * Additional bottom spacing of the element when it becomes sticky.
       * @type {Numeric|Function}
       */
      bottomSpacing: 0,

      /**
       * Container sidebar selector to know what the beginning and end of sticky element.
       * @type {String|False}
       */
      containerSelector: false,

      /**
       * Inner wrapper selector.
       * @type {String}
       */
      innerWrapperSelector: '.inner-wrapper-sticky',

      /**
       * The name of CSS class to apply to elements when they have become stuck.
       * @type {String|False}
       */
      stickyClass: 'is-affixed',

      /**
       * Detect when sidebar and its container change height so re-calculate their dimensions.
       * @type {Boolean}
       */
      resizeSensor: true,

      /**
       * The sidebar returns to its normal position if its width below this value.
       * @type {Numeric}
       */
      minWidth: false
  };

    // ---------------------------------
    // # Class Definition
    // ---------------------------------
    //
    /**
     * Sticky Sidebar Class.
     * @public
     */

    var StickySidebar = function () {

      /**
       * Sticky Sidebar Constructor.
       * @constructor
       * @param {HTMLElement|String} sidebar - The sidebar element or sidebar selector.
       * @param {Object} options - The options of sticky sidebar.
       */
      function StickySidebar(sidebar) {
      	var _this = this;

      	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      	_classCallCheck(this, StickySidebar);

      	this.options = StickySidebar.extend(DEFAULTS, options);

        // Sidebar element query if there's no one, throw error.
      	this.sidebar = 'string' === typeof sidebar ? document.querySelector(sidebar) : sidebar;
      	if ('undefined' === typeof this.sidebar) throw new Error("There is no specific sidebar element.");

      	this.sidebarInner = false;
      	this.container = this.sidebar.parentElement;

        // Current Affix Type of sidebar element.
      	this.affixedType = 'STATIC';
      	this.direction = 'down';
      	this.support = {
      		transform: false,
      		transform3d: false
      	};

      	this._initialized = false;
      	this._reStyle = false;
      	this._breakpoint = false;

        // Dimensions of sidebar, container and screen viewport.
      	this.dimensions = {
      		translateY: 0,
      		maxTranslateY: 0,
      		topSpacing: 0,
      		lastTopSpacing: 0,
      		bottomSpacing: 0,
      		lastBottomSpacing: 0,
      		sidebarHeight: 0,
      		sidebarWidth: 0,
      		containerTop: 0,
      		containerHeight: 0,
      		viewportHeight: 0,
      		viewportTop: 0,
      		lastViewportTop: 0
      	};

        // Bind event handlers for referencability.
      	['handleEvent'].forEach(function (method) {
      		_this[method] = _this[method].bind(_this);
      	});

        // Initialize sticky sidebar for first time.
      	this.initialize();
      }

      /**
       * Initializes the sticky sidebar by adding inner wrapper, define its container, 
       * min-width breakpoint, calculating dimensions, adding helper classes and inline style.
       * @private
       */


      _createClass(StickySidebar, [{
      	key: 'initialize',
      	value: function initialize() {
      		var _this2 = this;

      		this._setSupportFeatures();

          // Get sticky sidebar inner wrapper, if not found, will create one.
      		if (this.options.innerWrapperSelector) {
      			this.sidebarInner = this.sidebar.querySelector(this.options.innerWrapperSelector);

      			if (null === this.sidebarInner) this.sidebarInner = false;
      		}

      		if (!this.sidebarInner) {
      			var wrapper = document.createElement('div');
      			wrapper.setAttribute('class', 'inner-wrapper-sticky');
      			this.sidebar.appendChild(wrapper);

      			while (this.sidebar.firstChild != wrapper) {
      				wrapper.appendChild(this.sidebar.firstChild);
      			}this.sidebarInner = this.sidebar.querySelector('.inner-wrapper-sticky');
      		}

          // Container wrapper of the sidebar.
      		if (this.options.containerSelector) {
      			var containers = document.querySelectorAll(this.options.containerSelector);
      			containers = Array.prototype.slice.call(containers);

      			containers.forEach(function (container, item) {
      				if (!container.contains(_this2.sidebar)) return;
      				_this2.container = container;
      			});

      			if (!containers.length) throw new Error("The container does not contains on the sidebar.");
      		}

          // If top/bottom spacing is not function parse value to integer.
      		if ('function' !== typeof this.options.topSpacing) this.options.topSpacing = parseInt(this.options.topSpacing) || 0;

      		if ('function' !== typeof this.options.bottomSpacing) this.options.bottomSpacing = parseInt(this.options.bottomSpacing) || 0;

          // Breakdown sticky sidebar if screen width below `options.minWidth`.
      		this._widthBreakpoint();

          // Calculate dimensions of sidebar, container and viewport.
      		this.calcDimensions();

          // Affix sidebar in proper position.
      		this.stickyPosition();

          // Bind all events.
      		this.bindEvents();

          // Inform other properties the sticky sidebar is initialized.
      		this._initialized = true;
      	}
      }, {
      	key: 'bindEvents',
      	value: function bindEvents() {
      		window.addEventListener('resize', this, { passive: true, capture: false });
      		window.addEventListener('scroll', this, { passive: true, capture: false });

      		this.sidebar.addEventListener('update' + EVENT_KEY, this);

      		if (this.options.resizeSensor && 'undefined' !== typeof ResizeSensor) {
      			new ResizeSensor(this.sidebarInner, this.handleEvent);
      			new ResizeSensor(this.container, this.handleEvent);
      		}
      	}
      }, {
      	key: 'handleEvent',
      	value: function handleEvent(event) {
      		this.updateSticky(event);
      	}
      }, {
      	key: 'calcDimensions',
      	value: function calcDimensions() {
      		if (this._breakpoint) return;
      		var dims = this.dimensions;

          // Container of sticky sidebar dimensions.
      		dims.containerTop = StickySidebar.offsetRelative(this.container).top;
      		dims.containerHeight = this.container.clientHeight;
      		dims.containerBottom = dims.containerTop + dims.containerHeight;

          // Sidebar dimensions.
      		dims.sidebarHeight = this.sidebarInner.offsetHeight;
      		dims.sidebarWidth = this.sidebarInner.offsetWidth;

          // Screen viewport dimensions.
      		dims.viewportHeight = window.innerHeight;

          // Maximum sidebar translate Y.
      		dims.maxTranslateY = dims.containerHeight - dims.sidebarHeight;

      		this._calcDimensionsWithScroll();
      	}
      }, {
      	key: '_calcDimensionsWithScroll',
      	value: function _calcDimensionsWithScroll() {
      		var dims = this.dimensions;

      		dims.sidebarLeft = StickySidebar.offsetRelative(this.sidebar).left;

      		dims.viewportTop = document.documentElement.scrollTop || document.body.scrollTop;
      		dims.viewportBottom = dims.viewportTop + dims.viewportHeight;
      		dims.viewportLeft = document.documentElement.scrollLeft || document.body.scrollLeft;

      		dims.topSpacing = this.options.topSpacing;
      		dims.bottomSpacing = this.options.bottomSpacing;

      		if ('function' === typeof dims.topSpacing) dims.topSpacing = parseInt(dims.topSpacing(this.sidebar)) || 0;

      		if ('function' === typeof dims.bottomSpacing) dims.bottomSpacing = parseInt(dims.bottomSpacing(this.sidebar)) || 0;

      		if ('VIEWPORT-TOP' === this.affixedType) {
            // Adjust translate Y in the case decrease top spacing value.
      			if (dims.topSpacing < dims.lastTopSpacing) {
      				dims.translateY += dims.lastTopSpacing - dims.topSpacing;
      				this._reStyle = true;
      			}
      		} else if ('VIEWPORT-BOTTOM' === this.affixedType) {
            // Adjust translate Y in the case decrease bottom spacing value.
      			if (dims.bottomSpacing < dims.lastBottomSpacing) {
      				dims.translateY += dims.lastBottomSpacing - dims.bottomSpacing;
      				this._reStyle = true;
      			}
      		}

      		dims.lastTopSpacing = dims.topSpacing;
      		dims.lastBottomSpacing = dims.bottomSpacing;
      	}
      }, {
      	key: 'isSidebarFitsViewport',
      	value: function isSidebarFitsViewport() {
      		var dims = this.dimensions;
      		var offset = this.scrollDirection === 'down' ? dims.lastBottomSpacing : dims.lastTopSpacing;
      		return this.dimensions.sidebarHeight + offset < this.dimensions.viewportHeight;
      	}
      }, {
      	key: 'observeScrollDir',
      	value: function observeScrollDir() {
      		var dims = this.dimensions;
      		if (dims.lastViewportTop === dims.viewportTop) return;

      		var furthest = 'down' === this.direction ? Math.min : Math.max;

          // If the browser is scrolling not in the same direction.
      		if (dims.viewportTop === furthest(dims.viewportTop, dims.lastViewportTop)) this.direction = 'down' === this.direction ? 'up' : 'down';
      	}
      }, {
      	key: 'getAffixType',
      	value: function getAffixType() {
      		this._calcDimensionsWithScroll();
      		var dims = this.dimensions;
      		var colliderTop = dims.viewportTop + dims.topSpacing;
      		var affixType = this.affixedType;

      		if (colliderTop <= dims.containerTop || dims.containerHeight <= dims.sidebarHeight) {
      			dims.translateY = 0;
      			affixType = 'STATIC';
      		} else {
      			affixType = 'up' === this.direction ? this._getAffixTypeScrollingUp() : this._getAffixTypeScrollingDown();
      		}

          // Make sure the translate Y is not bigger than container height.
      		dims.translateY = Math.max(0, dims.translateY);
      		dims.translateY = Math.min(dims.containerHeight, dims.translateY);
      		dims.translateY = Math.round(dims.translateY);

      		dims.lastViewportTop = dims.viewportTop;
      		return affixType;
      	}
      }, {
      	key: '_getAffixTypeScrollingDown',
      	value: function _getAffixTypeScrollingDown() {
      		var dims = this.dimensions;
      		var sidebarBottom = dims.sidebarHeight + dims.containerTop;
      		var colliderTop = dims.viewportTop + dims.topSpacing;
      		var colliderBottom = dims.viewportBottom - dims.bottomSpacing;
      		var affixType = this.affixedType;

      		if (this.isSidebarFitsViewport()) {
      			if (dims.sidebarHeight + colliderTop >= dims.containerBottom) {
      				dims.translateY = dims.containerBottom - sidebarBottom;
      				affixType = 'CONTAINER-BOTTOM';
      			} else if (colliderTop >= dims.containerTop) {
      				dims.translateY = colliderTop - dims.containerTop;
      				affixType = 'VIEWPORT-TOP';
      			}
      		} else {
      			if (dims.containerBottom <= colliderBottom) {
      				dims.translateY = dims.containerBottom - sidebarBottom;
      				affixType = 'CONTAINER-BOTTOM';
      			} else if (sidebarBottom + dims.translateY <= colliderBottom) {
      				dims.translateY = colliderBottom - sidebarBottom;
      				affixType = 'VIEWPORT-BOTTOM';
      			} else if (dims.containerTop + dims.translateY <= colliderTop && 0 !== dims.translateY && dims.maxTranslateY !== dims.translateY) {
      				affixType = 'VIEWPORT-UNBOTTOM';
      			}
      		}

      		return affixType;
      	}
      }, {
      	key: '_getAffixTypeScrollingUp',
      	value: function _getAffixTypeScrollingUp() {
      		var dims = this.dimensions;
      		var sidebarBottom = dims.sidebarHeight + dims.containerTop;
      		var colliderTop = dims.viewportTop + dims.topSpacing;
      		var colliderBottom = dims.viewportBottom - dims.bottomSpacing;
      		var affixType = this.affixedType;

      		if (colliderTop <= dims.translateY + dims.containerTop) {
      			dims.translateY = colliderTop - dims.containerTop;
      			affixType = 'VIEWPORT-TOP';
      		} else if (dims.containerBottom <= colliderBottom) {
      			dims.translateY = dims.containerBottom - sidebarBottom;
      			affixType = 'CONTAINER-BOTTOM';
      		} else if (!this.isSidebarFitsViewport()) {

      			if (dims.containerTop <= colliderTop && 0 !== dims.translateY && dims.maxTranslateY !== dims.translateY) {
      				affixType = 'VIEWPORT-UNBOTTOM';
      			}
      		}

      		return affixType;
      	}
      }, {
      	key: '_getStyle',
      	value: function _getStyle(affixType) {
      		if ('undefined' === typeof affixType) return;

      		var style = { inner: {}, outer: {} };
      		var dims = this.dimensions;

      		switch (affixType) {
      			case 'VIEWPORT-TOP':
      			style.inner = { position: 'fixed', top: dims.topSpacing,
      			left: dims.sidebarLeft - dims.viewportLeft, width: dims.sidebarWidth };
      			break;
      			case 'VIEWPORT-BOTTOM':
      			style.inner = { position: 'fixed', top: 'auto', left: dims.sidebarLeft,
      			bottom: dims.bottomSpacing, width: dims.sidebarWidth };
      			break;
      			case 'CONTAINER-BOTTOM':
      			case 'VIEWPORT-UNBOTTOM':
      			var translate = this._getTranslate(0, dims.translateY + 'px');

      			if (translate) style.inner = { transform: translate };else style.inner = { position: 'absolute', top: dims.translateY, width: dims.sidebarWidth };
      			break;
      		}

      		switch (affixType) {
      			case 'VIEWPORT-TOP':
      			case 'VIEWPORT-BOTTOM':
      			case 'VIEWPORT-UNBOTTOM':
      			case 'CONTAINER-BOTTOM':
      			style.outer = { height: dims.sidebarHeight, position: 'relative' };
      			break;
      		}

      		style.outer = StickySidebar.extend({ height: '', position: '' }, style.outer);
      		style.inner = StickySidebar.extend({ position: 'relative', top: '', left: '',
      			bottom: '', width: '', transform: '' }, style.inner);

      		return style;
      	}
      }, {
      	key: 'stickyPosition',
      	value: function stickyPosition(force) {
      		if (this._breakpoint) return;

      		force = this._reStyle || force || false;

      		var offsetTop = this.options.topSpacing;
      		var offsetBottom = this.options.bottomSpacing;

      		var affixType = this.getAffixType();
      		var style = this._getStyle(affixType);

      		if ((this.affixedType != affixType || force) && affixType) {
      			var affixEvent = 'affix.' + affixType.toLowerCase().replace('viewport-', '') + EVENT_KEY;
      			StickySidebar.eventTrigger(this.sidebar, affixEvent);

      			if ('STATIC' === affixType) StickySidebar.removeClass(this.sidebar, this.options.stickyClass);else StickySidebar.addClass(this.sidebar, this.options.stickyClass);

      			for (var key in style.outer) {
      				var unit = 'number' === typeof style.outer[key] ? 'px' : '';
      				this.sidebar.style[key] = style.outer[key] + unit;
      			}

      			for (var _key in style.inner) {
      				var _unit = 'number' === typeof style.inner[_key] ? 'px' : '';
      				this.sidebarInner.style[_key] = style.inner[_key] + _unit;
      			}

      			var affixedEvent = 'affixed.' + affixType.toLowerCase().replace('viewport-', '') + EVENT_KEY;
      			StickySidebar.eventTrigger(this.sidebar, affixedEvent);
      		} else {
      			if (this._initialized) this.sidebarInner.style.left = style.inner.left;
      		}

      		this.affixedType = affixType;
      	}
      }, {
      	key: '_widthBreakpoint',
      	value: function _widthBreakpoint() {

      		if (window.innerWidth <= this.options.minWidth) {
      			this._breakpoint = true;
      			this.affixedType = 'STATIC';

      			this.sidebar.removeAttribute('style');
      			StickySidebar.removeClass(this.sidebar, this.options.stickyClass);
      			this.sidebarInner.removeAttribute('style');
      		} else {
      			this._breakpoint = false;
      		}
      	}
      }, {
      	key: 'updateSticky',
      	value: function updateSticky() {
      		var _this3 = this;

      		var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      		if (this._running) return;
      		this._running = true;

      		(function (eventType) {
      			requestAnimationFrame(function () {
      				switch (eventType) {
                // When browser is scrolling and re-calculate just dimensions
                // within scroll. 
      					case 'scroll':
      					_this3._calcDimensionsWithScroll();
      					_this3.observeScrollDir();
      					_this3.stickyPosition();
      					break;

                // When browser is resizing or there's no event, observe width
                // breakpoint and re-calculate dimensions.
      					case 'resize':
      					default:
      					_this3._widthBreakpoint();
      					_this3.calcDimensions();
      					_this3.stickyPosition(true);
      					break;
      				}
      				_this3._running = false;
      			});
      		})(event.type);
      	}
      }, {
      	key: '_setSupportFeatures',
      	value: function _setSupportFeatures() {
      		var support = this.support;

      		support.transform = StickySidebar.supportTransform();
      		support.transform3d = StickySidebar.supportTransform(true);
      	}
      }, {
      	key: '_getTranslate',
      	value: function _getTranslate() {
      		var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      		var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      		var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      		if (this.support.transform3d) return 'translate3d(' + y + ', ' + x + ', ' + z + ')';else if (this.support.translate) return 'translate(' + y + ', ' + x + ')';else return false;
      	}
      }, {
      	key: 'destroy',
      	value: function destroy() {
      		window.removeEventListener('resize', this, { capture: false });
      		window.removeEventListener('scroll', this, { capture: false });

      		this.sidebar.classList.remove(this.options.stickyClass);
      		this.sidebar.style.minHeight = '';

      		this.sidebar.removeEventListener('update' + EVENT_KEY, this);

      		var styleReset = { inner: {}, outer: {} };

      		styleReset.inner = { position: '', top: '', left: '', bottom: '', width: '', transform: '' };
      		styleReset.outer = { height: '', position: '' };

      		for (var key in styleReset.outer) {
      			this.sidebar.style[key] = styleReset.outer[key];
      		}for (var _key2 in styleReset.inner) {
      			this.sidebarInner.style[_key2] = styleReset.inner[_key2];
      		}if (this.options.resizeSensor && 'undefined' !== typeof ResizeSensor) {
      			ResizeSensor.detach(this.sidebarInner, this.handleEvent);
      			ResizeSensor.detach(this.container, this.handleEvent);
      		}
      	}
      }], [{
      	key: 'supportTransform',
      	value: function supportTransform(transform3d) {
      		var result = false,
      		property = transform3d ? 'perspective' : 'transform',
      		upper = property.charAt(0).toUpperCase() + property.slice(1),
      		prefixes = ['Webkit', 'Moz', 'O', 'ms'],
      		support = document.createElement('support'),
      		style = support.style;

      		(property + ' ' + prefixes.join(upper + ' ') + upper).split(' ').forEach(function (property, i) {
      			if (style[property] !== undefined) {
      				result = property;
      				return false;
      			}
      		});
      		return result;
      	}
      }, {
      	key: 'eventTrigger',
      	value: function eventTrigger(element, eventName, data) {
      		try {
      			var event = new CustomEvent(eventName, { detail: data });
      		} catch (e) {
      			var event = document.createEvent('CustomEvent');
      			event.initCustomEvent(eventName, true, true, data);
      		}
      		element.dispatchEvent(event);
      	}
      }, {
      	key: 'extend',
      	value: function extend(defaults, options) {
      		var results = {};
      		for (var key in defaults) {
      			if ('undefined' !== typeof options[key]) results[key] = options[key];else results[key] = defaults[key];
      		}
      		return results;
      	}
      }, {
      	key: 'offsetRelative',
      	value: function offsetRelative(element) {
      		var result = { left: 0, top: 0 };

      		do {
      			var offsetTop = element.offsetTop;
      			var offsetLeft = element.offsetLeft;

      			if (!isNaN(offsetTop)) result.top += offsetTop;

      			if (!isNaN(offsetLeft)) result.left += offsetLeft;

      			element = 'BODY' === element.tagName ? element.parentElement : element.offsetParent;
      		} while (element);
      		return result;
      	}
      }, {
      	key: 'addClass',
      	value: function addClass(element, className) {
      		if (!StickySidebar.hasClass(element, className)) {
      			if (element.classList) element.classList.add(className);else element.className += ' ' + className;
      		}
      	}
      }, {
      	key: 'removeClass',
      	value: function removeClass(element, className) {
      		if (StickySidebar.hasClass(element, className)) {
      			if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      		}
      	}
      }, {
      	key: 'hasClass',
      	value: function hasClass(element, className) {
      		if (element.classList) return element.classList.contains(className);else return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
      	}
      }, {
      	key: 'defaults',
      	get: function () {
      		return DEFAULTS;
      	}
      }]);

return StickySidebar;
}();

return StickySidebar;
}();

exports.default = StickySidebar;


  // Global
  // -------------------------
window.StickySidebar = StickySidebar;
});
});

var stickySidebar$1 = unwrapExports(stickySidebar);

exports['default'] = stickySidebar$1;
exports.__moduleExports = stickySidebar;

Object.defineProperty(exports, '__esModule', { value: true });

})));

//# sourceMappingURL=sticky-sidebar.js.map
// END sticky-sidebar.js


//Collection page sticky filters initialisation - BEGIN
$(document).ready(function(){
	if ($("#affix-sidebar").length > 0) {

		$('.mobile__show-filters').click(function () {
			$("body").addClass('filters-opened');
			$('#affix-sidebar .affix-sidebar__inner').addClass('active');
		});

		$('.collection__sidebar-cta .hide--filters, .collection__sidebar-header .icon-cross').click(function () {
			$("body").removeClass('filters-opened');
			$('#affix-sidebar .affix-sidebar__inner').removeClass('active');
		});

		var winWidth = $(window).width();

  // if (winWidth >= 750 && winWidth <= 959 ){}
		if($('#countdown-header').length > 0 ){
			if (winWidth > 798 ) {
				var a = new StickySidebar('#affix-sidebar', {
					topSpacing: 80,
					bottomSpacing: 0,
					containerSelector: '.sticky-container',
					innerWrapperSelector: '.affix-sidebar__inner',
					resizeSensor: true
				});

			}
		}else{
			if (winWidth > 798 ) {
				var a = new StickySidebar('#affix-sidebar', {
					topSpacing: 15,
					bottomSpacing: 0,
					containerSelector: '.sticky-container',
					innerWrapperSelector: '.affix-sidebar__inner',
					resizeSensor: true
				});

			}
		}

	// $('.sidebar').removeClass('toggle-all--false').addClass('toggle-all--true');
		
	}

});

//Collection page sticky filters initialisation - END

//BBB END - Collection page - sticky filters


// collection page
if ($("body.collection").length ) {

	$( ".show_multiple_select" ).each(function(index) {
		$(this).change(function(){
			var prodID = $(this).attr("data-productid");
			var rc_id = $(this).find(':selected').attr("data-rc-id");
			
			// Recharge id's
			$('#rc_id_'+prodID).val(rc_id);
			// Recharge id's end

		});
	});


	$( ".variants-selection" ).each(function(index) {
		$(this).change(function(){
			var prodID = $(this).attr("data-productid");
			var vImg = $(this).find(':selected').attr("data-img");
			var vColor = $(this).find(':selected').attr("data-color");
			var vPrice = $(this).find(':selected').attr("data-var-price");
			var vWasPrice = $(this).find(':selected').attr("data-was-price");
			var vUrl = $(this).find(':selected').attr("data-url");

			var original_id = $(this).val();
			var rc_id = $(this).find(':selected').attr("data-rc-id");

			$('#product-form-'+prodID+'+ p.warning').remove();

			var qty = $('#product-form-'+prodID+' div.product__purchase input').val();
			
			$('.img__'+prodID ).closest("a").attr("href", vUrl);
			$('.img__'+prodID+ ' img').attr({'src':vImg , 'data-srcset':vImg , 'srcset':vImg });
			$('.img__'+prodID+ ' .bkg-box').css({'background-color': vColor });

			// Recharge id's
			$('#rc_id_'+prodID).val(rc_id);
			// Recharge id's end

			var totalPrice = ((Math.round(vPrice * 100) / 100) * qty).toFixed(2);
			$('.money_'+prodID).attr('data-price', vPrice);

			if(totalPrice == 0){
				$('.money_'+prodID).html('');
			}else{
				$('.money_'+prodID).html(Shopify.formatMoney(totalPrice, $('body').data('money-format')));
			}

			// $('.money_'+prodID).html(Shopify.formatMoney(totalPrice, $('body').data('money-format')));

			var wasTotalPrice = ((Math.round(vWasPrice * 100) / 100) * qty).toFixed(2);
			$('.was_price_'+prodID).attr('data-was-price', vWasPrice);

			if(wasTotalPrice == 0){
				$('.was_price_'+prodID+' .money').html('');
			}else{
				$('.was_price_'+prodID+' .money').html(Shopify.formatMoney(wasTotalPrice, $('body').data('money-format'))); 
			}

		});
	});


	$(".single-option-selector").each(function(index) {
		$(this).change(function(){
			var prodID = $(this).attr("data-productid");
			var selector_1 = $('#product-form-'+prodID+' .multiselect__type').val();
			var selector_2 = $('#product-form-'+prodID+' .multiselect__qty').val();

			var selectorStatus = true;
			if(selector_1 != null && selector_2 != null){
				var selector = selector_1 + ' / '+ selector_2;	
				
			}else{
				selectorStatus = false;
				var selector = ' ';	
			}

            // alert(selector);
			// $('#product-form-'+prodID+' .variants-selection option:selected').removeAttr('selected');
			// $('#product-form-'+prodID+' .variants-selection option[data-value="'+selector+'"]').attr("selected",true);
			// $('#product-form-'+prodID+' .variants-selection option:contains('+selector+')').attr("selected",true);
			
			var variantStatus = true;
			if (!$('#product-form-'+prodID+' .variants-selection option[data-value="' + selector + '"]').prop("selected", true).length) {
				variantStatus = false;
				// alert('No such option');
			}
			
			var vImg = $('#product-form-'+prodID+' .variants-selection option:contains('+selector+')').attr("data-img");
			var vColor = $('#product-form-'+prodID+' .variants-selection option:contains('+selector+')').attr("data-color");
			var vPrice = $('#product-form-'+prodID+' .variants-selection option:contains('+selector+')').attr("data-var-price");
			var wasItemPrice = $('#product-form-'+prodID+' .variants-selection option:contains('+selector+')').attr('data-was-price');
			var vUrl = $('#product-form-'+prodID+' .variants-selection option:contains('+selector+')').attr("data-url");

			$('.img__'+prodID ).closest("a").attr("href", vUrl);
			$('.img__'+prodID+ ' img').attr({'src':vImg , 'data-srcset':vImg , 'srcset':vImg });
			$('.img__'+prodID+ ' .bkg-box').css({'background-color': vColor });

			if(selector == '4-PACK VARIETY / 1' || selector == '4-PACK VARIETY / 2' || selector == '4-PACK VARIETY / 3'){
				selector_2 = selector_2 * 4;
			}
			var savings = (((wasItemPrice - vPrice)* 100) / 100).toFixed(2);
			var unitPrice = ((Math.round(vPrice * 100) / 100)/ selector_2).toFixed(2);

			if(!variantStatus || !selectorStatus){
				$('.money_'+prodID).html('');
				$('.money_'+prodID+'+ span.savings').remove();
				$('.was_price_'+prodID+' .money').html('');
				$('.addtocart_'+prodID).addClass('sold_out').attr('disabled','true');
				$('.addtocart_'+prodID+' .text').text('SOLD OUT');

				$('#product-form-'+prodID+' .variants-selection').val("");

			}else{
				$('.addtocart_'+prodID).removeClass('sold_out').removeAttr("disabled");	
				if($("body").hasClass("collection-build-your-bundle")) {
                $('.addtocart_'+prodID+' .text').html('Add to <span>bundle</span>');
				}else{
				$('.addtocart_'+prodID+' .text').text('Add to cart');	
				}

				// $('.addtocart_'+prodID+' .text').text('Add to cart');	
				
				$('.money_'+prodID).html(Shopify.formatMoney(vPrice, $('body').data('money-format')));
				$('#product-form-'+prodID+'+ p.warning').remove();

				if(savings > 0){
					$('.money_'+prodID+'+ span.savings').remove();
					$('.money_'+prodID).after('<span class="savings"><span class="item-money">' + Shopify.formatMoney(unitPrice, $('body').data('money-format')) + '</span>/loaf (You Save <span class="item-money">'+ Shopify.formatMoney(savings, $('body').data('money-format')) + '</span>)</span>');
				}else{
					$('.money_'+prodID+'+ span.savings').remove();
					// $('.was_price_'+prodID+' .money').html('');
				}
			}

			
		});
	});
}// collection page

// build your bundle collection	
if ($(".collection-build-your-bundle").length ) {
	$(window).scroll(function() {
		if ($(document).scrollTop() > 200) {
			$('#progress-bar').addClass('collection__header--sticky');
			$('.static-progress-bar').hide();
		}
		else {
			$('#progress-bar').removeClass('collection__header--sticky');
			$('.static-progress-bar').show();
		}
	});
}// build your bundle collection

// BBB Custom collection filters - Begin
$(document).ready(function(){
	if ($("#affix-sidebar").length > 0) {

		$.fn.hasAnyClass = function() {
			for (var i = 0; i < arguments.length; i++) {
				var classes = arguments[i].split(" ");
				for (var j = 0; j < classes.length; j++) {
					if (this.hasClass(classes[j])) {
						return true;
					}
				}
			}
			return false;
		}

		var product,
		selectedOptions,
		activeFiltersList,
		product_total,
		filters_active,
		clear_active_filters = $(".clear--filters"),
		apply_filters = $(".hide--filters"),
		product = $(".collection-all-grid .thumbnail"),
		product_total_container = $('#prod-count');
		product_total = 0;

		product.each(function () {
			if ($(this).is(":visible")) {
				product_total++;
			}
		});

        // product_total_container.text(product_total + ' Products');
        // alert(product_total);

		$('[data-filter-value]').click(function () {
			var product = $(".collection-all-grid .thumbnail");

			product.hide();

			selectedOptions = [];

			product_total = 0;
			filters_active = 0;

			$('[data-filter-value] input:checked').each(function (){
				filters_active++;
				selectedOptions.push($(this).val());
			});

			// alert(filters_active);
			// console.log(filters_active);

			if(filters_active > 0) {
				$(clear_active_filters).show();
				$(apply_filters).show();
				$('#filters-counter').text('').text('('+filters_active+')');
				
			} else {
				$('#filters-counter').text('');
				$(clear_active_filters).hide();
				$(apply_filters).hide();
				product.show();
			}

			activeFiltersList = selectedOptions.join(' ');

			// console.log(activeFiltersList);

			product.each(function () {

				if ($(this).hasAnyClass(activeFiltersList)) {
					$(this).show();
				}

				if ($(this).is(":visible")) {
					product_total++;
				}

				if (product_total > 0) {
					$('.collection__no-results').hide();
				} else {
					$('.collection__no-results').show();
				}
			});

			if (product_total === 1) {
				product_total_container.html('('+product_total + ')');
			} else {
				product_total_container.html('('+product_total + ')');
			}

// reinitialize sticky sidebar
			var winWidth = $(window).width();
			if($('#countdown-header').length > 0 ){
				if (winWidth > 798 ) {
					var a = new StickySidebar('#affix-sidebar', {
						topSpacing: 80,
						bottomSpacing: 0,
						containerSelector: '.sticky-container',
						innerWrapperSelector: '.affix-sidebar__inner',
						resizeSensor: true
					});
				}
			}else{
				if (winWidth > 798 ) {
					var a = new StickySidebar('#affix-sidebar', {
						topSpacing: 15,
						bottomSpacing: 0,
						containerSelector: '.sticky-container',
						innerWrapperSelector: '.affix-sidebar__inner',
						resizeSensor: true
					});
				}
			}
    // reinitialize sticky sidebar

      // smoth scrolling to the product list - begin
      // Store hash
			// var hash = $('#prodList');

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
			// $('html, body').animate({
			// 	scrollTop: $('#prodList').offset().top - 115
			// }, 700, function(){

      // Add hash (#) to URL when done scrolling (default click behavior)
			// 	window.location.hash = '#prodList';
			// });
      // smoth scrolling to the product list - end

		});

        // clear filters - begin
		$(clear_active_filters).click(function () {
			
			$('[data-filter-value]').each(function (){
				if($(this).find('input').is(':checked')){
					$(this).trigger('click');
				}
			});

			product.hide();
			product_total = 0;

			product.each(function () {
				$(this).show();
				product_total++;

				if (product_total > 0) {
					$('.collection__no-results').hide();
				} else {
					$('.collection__no-results').show();
				}

			});

			$('.clear--filters').hide();
			$('#filters-counter').text('');
			$('.collection__sidebar-cta .hide--filters').hide();

			if (product_total === 1) {
				product_total_container.html('('+product_total + ')');
			} else {
				product_total_container.html('('+product_total + ')');
			}

		});
		// clear filters - end

	}
});
// BBB Custom collection filters - End


// custom mini cart - begin
$("a.open__minicart").on("click",function(){
	if ($("body").hasClass("is-visible")) {
      // $(".sidebar_cart_container").removeClass("active");
		
		$("html").removeClass("no-scroll");
		$("body").removeClass("is-visible");

	} else {
      // $(".sidebar_cart_container").addClass("active");
      // $(".sidebar_cart_items").addClass("focus");

      // setTimeout(function() { 
      //   $(".sidebar_cart_items").removeClass("focus");
      // }, 4000);
		
		$("html").addClass("no-scroll");
		$("body").addClass("is-visible");
	}      

});

$("body").on("click",".js-cart-close, .PageOverlay, .cart_content__continue-shopping",function(){
	$("body").removeClass("is-visible");
	$("html").removeClass("no-scroll");
});

// nav search bar
$(".kiss-topright-menu .search-item").on("click",function(e){
e.preventDefault();
$(".search-box-column .search-box").show();
});

$(".zl_new_header_search .icon-close").on("click",function(){
$(".search-box-column .search-box, .algolia-autocomplete").hide();
});
// nav search bar

// remove item mini cart
$("body").on("click",".remove_frm_cart", function() {
	$(this).parent().find('.product-quantity-box input').val(0).change();
	$(this).parent().addClass('animated fadeOutUp');
});


// if ($('.announcement_banner').length){
// 	$('body').addClass('announcement_banner-show');
// }